import type { CustomerDiscriminator } from "../models/Customer";

export type OrderableColumns = "active" | "discr" | "name";

export const CUSTOMER_DISCRIMINATOR = {
  PSP: "payment_service_provider",
  MERCHANT: "merchant",
  TSP: "technical_service_provider",
  ORGANISATION: "organisation",
  SUBMERCHANT: "submerchant",
} as const;

export const CUSTOMER_DISCRIMINATOR_LIST: CustomerDiscriminator[] = [
  CUSTOMER_DISCRIMINATOR.PSP,
  CUSTOMER_DISCRIMINATOR.TSP,
  CUSTOMER_DISCRIMINATOR.MERCHANT,
  CUSTOMER_DISCRIMINATOR.ORGANISATION,
  CUSTOMER_DISCRIMINATOR.SUBMERCHANT,
];

// The "merchant family": every type that is not a PSP/TSP root provider.
// These all share merchant behaviour (integrator field, product flags, hierarchy cell).
export const MERCHANT_LIKE_DISCRIMINATORS: CustomerDiscriminator[] = [
  CUSTOMER_DISCRIMINATOR.MERCHANT,
  CUSTOMER_DISCRIMINATOR.ORGANISATION,
  CUSTOMER_DISCRIMINATOR.SUBMERCHANT,
];

// A billing parent may be any customer type except a submerchant.
export const BILLING_PARENT_DISCRIMINATORS: CustomerDiscriminator[] =
  CUSTOMER_DISCRIMINATOR_LIST.filter(
    (discr) => discr !== CUSTOMER_DISCRIMINATOR.SUBMERCHANT
  );

// Single source of truth for the parent hierarchy rules: for a customer of a
// given discriminator, which discriminators may be its parent.
export const ALLOWED_PARENT_DISCRIMINATORS: Record<
  CustomerDiscriminator,
  CustomerDiscriminator[]
> = {
  [CUSTOMER_DISCRIMINATOR.MERCHANT]: [
    CUSTOMER_DISCRIMINATOR.MERCHANT,
    CUSTOMER_DISCRIMINATOR.ORGANISATION,
  ],
  [CUSTOMER_DISCRIMINATOR.ORGANISATION]: [CUSTOMER_DISCRIMINATOR.ORGANISATION],
  [CUSTOMER_DISCRIMINATOR.SUBMERCHANT]: [
    CUSTOMER_DISCRIMINATOR.SUBMERCHANT,
    CUSTOMER_DISCRIMINATOR.MERCHANT,
  ],
  [CUSTOMER_DISCRIMINATOR.PSP]: [
    CUSTOMER_DISCRIMINATOR.PSP,
    CUSTOMER_DISCRIMINATOR.TSP,
  ],
  [CUSTOMER_DISCRIMINATOR.TSP]: [
    CUSTOMER_DISCRIMINATOR.PSP,
    CUSTOMER_DISCRIMINATOR.TSP,
  ],
};

export const CUSTOMER_DISCR_TO_SHORTHAND = new Map<
  CustomerDiscriminator,
  string
>([
  ["technical_service_provider", "TSP"],
  ["payment_service_provider", "PSP"],
]);
